import firebase from "firebase";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDGFbALGZD3jvoexHLKIOn0_GAabVwd1vQ",
  authDomain: "escuela.app",
  databaseURL: "https://escuelapp-5f754.firebaseio.com",
  projectId: "escuelapp-5f754",
  storageBucket: "gs://escuelapp-5f754.appspot.com",
  messagingSenderId: "217574078407",
};

let USER = {};

firebase.initializeApp(config);

const auth = firebase.auth();
const database = firebase.database();

const cleanCacheInLogout = function () {
  USER = {};
};

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

export {
  cleanCacheInLogout,
  auth,
  database,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
};



// WEBPACK FOOTER //
// ./firebase/firebase.js